import { Yendo } from '../src/components'

export default function YendoPage() {
  return <>
    <Yendo />
  </>
}